export default (object) => {
  return Object.keys(object)
    .filter((a) => object[a])
    .map((b) => `${b}=${object[b]}`)
    .join("&");
};
